"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = void 0;
/**
 * This error is quite verbose but it should make debugging issues much easier
 */
class ApiError extends Error {
    constructor(message, errorCode, statusCode, url, method, data) {
        super(message);
        this.errorCode = errorCode;
        this.statusCode = statusCode;
        this.url = url;
        this.method = method;
        this.data = data;
    }
}
exports.ApiError = ApiError;
//# sourceMappingURL=errors.js.map